var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BigNumber } from "@ethersproject/bignumber";
import { useContext } from "react";
import { CHAINS_TO_ID, isSolanaVault, VaultAddressMap, VaultList, VaultVersionList, } from "../constants/constants";
import { isEVMChain, isSolanaChain } from "../utils/chains";
import { SubgraphDataContext } from "./subgraphDataContext";
var getVaultPriceHistoryKey = function (vault) {
    return "vaultPriceHistory_" + vault.replace(/-/g, "");
};
export var vaultPriceHistoryGraphql = function (version, chain) {
    return VaultList.reduce(function (acc, vault) {
        var vaultAddress = VaultAddressMap[vault][version];
        if (!isSolanaVault(vault) &&
            (!vaultAddress || VaultAddressMap[vault].chainId !== CHAINS_TO_ID[chain])) {
            return acc;
        }
        if (isEVMChain(chain)) {
            vaultAddress = vaultAddress === null || vaultAddress === void 0 ? void 0 : vaultAddress.toLowerCase();
        }
        return (acc +
            ("\n        " + getVaultPriceHistoryKey(vault) + ": vaultPerformanceUpdates(\n          " + (isSolanaChain(chain)
                ? "where: { vaultId: {_in: [\"" + vaultAddress + "\"]} },"
                : "where: { vault_in: [\"" + vaultAddress + "\"] },") + "\n          " + (isSolanaChain(chain)
                ? "order_by: { timestamp: desc },"
                : "orderBy: timestamp,\n                 orderDirection: desc,") + "\n          " + (isSolanaChain(chain) ? "limit: 1000" : "first: 1000") + "\n        ) {\n          pricePerShare\n          timestamp\n          " + (version !== "v1" ? "round" : "") + "\n        }\n      "));
    }, "");
};
export var resolveVaultPriceHistorySubgraphResponse = function (responses) {
    return Object.fromEntries(VaultVersionList.map(function (version) { return [
        version,
        Object.fromEntries(VaultList.map(function (vault) {
            var priceHistory = responses[version][getVaultPriceHistoryKey(vault)];
            return [
                vault,
                priceHistory
                    ? priceHistory
                        .map(function (history) { return (__assign(__assign({}, history), { pricePerShare: BigNumber.from(history.pricePerShare) })); })
                        .reverse()
                    : [],
            ];
        })),
    ]; }));
};
var useVaultPriceHistory = function (vaultOption, vaultVersion) {
    var contextData = useContext(SubgraphDataContext);
    return {
        priceHistory: contextData.vaultSubgraphData.vaultPriceHistory[vaultVersion][vaultOption],
        loading: contextData.vaultSubgraphData.loading,
    };
};
export var useVaultsPriceHistory = function () {
    var contextData = useContext(SubgraphDataContext);
    return {
        data: contextData.vaultSubgraphData.vaultPriceHistory,
        loading: contextData.vaultSubgraphData.loading,
    };
};
export default useVaultPriceHistory;
//# sourceMappingURL=useVaultPerformanceUpdate.js.map